export default "__VITE_ASSET__LTUQ9XTa__"